<template>
	<teleport to="body">
		<!-- 1. 给遮罩层添加点击事件 handleMaskClick -->
		<div class="modal-mask" v-if="visible" @click="handleMaskClick()">
			<!-- 2. 给弹窗容器添加点击事件阻止冒泡 -->
			<div class="modal-container" @click.stop>
				<div class="modal-header">
					<span>{{ title }}</span>
					<button @click="handleClose()">×</button>
				</div>
				<div class="modal-body" style="width: 40vw;height: auto;">
					<div style="margin: 3% 14% 0% 7%;">
						<el-form :model="printForm" :rules="printRules" ref="printForm" label-width="6em">
							<el-form-item v-if="!isReprint" label="电子面单" prop="expressAccountId">
								<el-select v-model="printForm.expressAccountName" value-key="id"
									@change="selectExpressAccount" placeholder="请选择电子面单" :loading="accountLoading"
									style="width: 100%;">
									<el-option v-for="item in express_account_list" :key="item.id"
										:label="item.nickname" :value="item">
										<span
											style="float: left;position: relative;left: -2%;">{{ item.nickname }}</span>
										<span
											style="float: right; color: #2ea2e0; font-size: 0.9em">{{ item.quota }}</span>
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="打印机" prop="printer">
								<el-select v-model="printForm.printer" :loading="printLoading"
									@visible-change="getLocal_kb_Printer()" placeholder="请选择打印机" style="width: 100%;">
									<el-option v-for="i in printerList" :key="i.name" :label="i.name" :value="i.name">
										<span style="float: left">{{ i.name }}</span>
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="打印模板" prop="PrintTemplate">
								<el-select v-model="printForm['templateId']" placeholder="请选择打印模板"
									no-data-text="请先选择电子面单" style="width: 100%;">
									<el-option v-for="i in printTemplateList[printForm['cpCode']]" :key="i.templateId"
										:label="i.templateName" :value="i.templateId">
										<span
											style="float: left;position: relative;left: -2%;">{{ i.templateName }}</span>
										<a :href="'https://upload.kuaidihelp.com/CloudPrint/template/previewImages/'+i.templateId+'.png'"
											target="_blank"
											style="float: right; color: #2ea2e0; font-size: 0.9em;text-decoration:none;">查看模板</a>
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item style="margin-top: 10%;margin-bottom: 8%;">
								<el-button plain @click="printWaybill('getWaybill')" style="margin-left: 6%;"
									:disabled="orderContent['orderStatusCode']!='CREATE' || printingProgress == true">仅获取运单</el-button>
								<el-button type="primary" @click="printWaybill('printWaybill')"
									:disabled="printingProgress == true" style="margin-left: 18%;">打印面单</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<!-- <div class="modal-footer">
          <button @click="handleClose()">关闭</button>
        </div> -->
			</div>
		</div>
	</teleport>
</template>

<script>
	import {
		ElMessage,
		ElButton,
		ElForm,
		ElFormItem,
		ElSelect,
		ElOption,
		ElLoading
	} from 'element-plus'
	import apiService from "../../../../src/util/apiService.js"
	export default {
		components: {
			ElButton,
			ElForm,
			ElFormItem,
			ElSelect,
			ElOption,
		},
		// 选项式API：定义接收的属性
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: '运单打印'
			},
			// orderNo: {
			// 	type: String,
			// 	default: null
			// },
			orderContent: {
				type: Object,
				default: null
			},
			isReprint: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				data: [],
				orderNo: null,
				kbPrinter: null,
				printerList: [],
				printForm: {
					expressAccountId: '', //选中的电子面单账号
					expressAccountName: '', //选中的电子面单账号
					cpCode: '', //选中的电子面单账号所属快递公司编码
					printer: '', //选中的打印机
					templateId: '', //打印模板
				},
				//电子面单账号列表
				express_account_list: [],
				accountLoading: false,
				printLoading: false,
				printTemplateList: {
					'ZTO': [{
							'templateName': '中通标准一联单	',
							'templateId': '666705'
						},
						{
							'templateName': '菜鸟一联单',
							'templateId': '666717'
						}
					],
					'YTO': [{
							'templateName': '圆通标准一联单',
							'templateId': '666696'
						},
						{
							'templateName': '菜鸟一联单',
							'templateId': '666718'
						},
						{
							'templateName': '圆通一联单（WG）',
							'templateId': '666838'
						}
					],
					'JT': [{
							'templateName': '极兔标准一联单	',
							'templateId': '666725'
						},
						{
							'templateName': '极兔快递一联单',
							'templateId': '195029'
						}
					]
				},
				//打印弹窗校验
				printRules: {
					/* printer: [
					  { required: true, message: '请选择打印机', trigger: 'blur' },
					], */
					expressAccountId: [{
						required: true,
						message: '请选择电子面单账户',
						trigger: 'change'
					}, ]
				},
				isConnected: false, // 连接状态
				kbPrinterMsgList: [], // 消息列表
				//点击获取运单后改变状态
				isObtainedWaybill: false,
				printingProgress: false
			}
		},
		// 也可以在mounted中打印（组件挂载时）
		mounted() {

			// 因为visible初始可能为false，这里加个判断
			if (this.visible) {
				//读取默认打印设置
				var printForm = JSON.parse(localStorage.getItem('printForm'));
				if (printForm) {
					//默认打印机
					this.printForm.printer = printForm.printer;
					//默认电子面单
					if (this.orderContent["orderStatusCode"] == "CREATE") {
						this.printForm.expressAccountId = printForm.expressAccountId;
						this.printForm.expressAccountName = printForm.expressAccountName;
					}
					//默认打印模板
					if (this.orderContent["cpCode"] == printForm["cpCode"]) {
						this.printForm.templateId = printForm.templateId;
						this.printForm.cpCode = printForm.cpCode;
					}
					if (this.orderContent["orderStatusCode"] == "CREATE") {
						this.printForm.cpCode = printForm.cpCode;
						this.printForm.templateId = printForm.templateId;
					}

				}
				this.getExpressAccountList();
				this.connect_Kb_Printer();
				if (this.isReprint) {
					this.printForm['cpCode'] = this.orderContent['cpCode'];
				}

			}
		},
		// 选项式API：定义方法
		methods: {
			async printWaybill(type) {
				this.printingProgress = true;
				//存储默认打印设置
				localStorage.setItem('printForm', JSON.stringify(this.printForm));
				//取号一旦出错先刷新避免重复点击取号
				try {
					var orderContent = this.orderContent;
					if (!orderContent) {
						ElMessage.error('订单信息不存在');
						return false
					}
					var orderNo = orderContent.orderNo;
					this.orderNo = orderNo;
					var orderStatusCode = orderContent.orderStatusCode;
					if (orderStatusCode == "CREATE") {
						var waybillData_Res = await this.getWaybill(orderNo, this.printForm.expressAccountId)
						if (!waybillData_Res) {
							ElMessage.error("运单获取失败");
							return false
						}
					
						var waybillData = waybillData_Res;
						console.log(waybillData)
						//更新订单数据，把获取到的运单数据加进去
						// orderContent["orderNo"] = waybillData["orderNo"];
						orderContent["waybillNo"] = waybillData["waybillNo"];
						try {
							orderContent["sortInfo"] = {
								assemblyPointCode: waybillData["assemblyPointCode"],
								assemblyPointName: waybillData["assemblyPointName"],
								belongOrgCode: "",
								belongOrgName: "",
								destAddressKeyWord: "",
								productCode: "",
								qrCode: "",
								sortingCode: waybillData["sortingCode"]
							}
						} catch (e) {
							orderContent["sortInfo"] = {
								assemblyPointCode: "",
								assemblyPointName: "",
								belongOrgCode: "",
								belongOrgName: "",
								destAddressKeyWord: "",
								productCode: "",
								qrCode: "",
								sortingCode: ""
							}
							console.log("异常", e)
						}
					}
					if (type == 'getWaybill') {
						ElMessage({
							message: '取号成功',
							type: 'success',
						})
						location.reload();
					} else if (type == 'printWaybill') {
						if (!this.printForm['printer']) {
							ElMessage.error('请选择打印机');
							return false
						}
						if (!this.printForm['templateId']) {
							ElMessage.error('请选择打印模板');
							return false
						}
						console.log()
						this.print(orderContent, this.printForm)
					} else {
						return false
					}
				} catch (e) {
					console.log("打印异常", e)
				}

			},
			//获取运单
			async getWaybill(orderNo, expressAccountId) {
				//点击获取后不能再次获取，避免报错时候用户多次点击重复取号
				if (this.isObtainedWaybill != false) {
					ElMessage.error('打印锁定，请刷新后再试');
				}
				this.isObtainedWaybill = true;
				var result = null
				try {
					const loading = ElLoading.service({
						lock: true,
						text: '获取运单中',
						background: 'rgba(0, 0, 0, 0.7)',
					})

					await apiService.post({
							modules: "getWaybill",
							content: {
								orderNo: orderNo,
								expressAccountId: expressAccountId
							}
						})
						.then((res) => {
							//成功
							if (res.status) {
								result = res.data;
							}
							//订阅运单号
							try {
								if(result.cpCode == "YTO"){
									apiService.post({
											modules: "subscriptionWaybill",
											content: {
												cpCode: result.cpCode,
												waybillNo: result.waybillNo,
												phone: ""
											}
										})
										.then((res) => {
											console.log(res)
										})
								}
							
							} catch(e) {
								console.log(e)
							}
						})
						.finally(() => {
							loading.close();
						})

				} catch (e) {
					//TODO handle the exception
				}
				return result
			},
			//快宝本地打印
			print(orderContent, printForm) {
				var param = {
					"cmd": "print",
					"requestID": String(new Date().getTime()),
					"version": "1.0",
					"printer_name": printForm['printer'],
					//"agent_id":"",
					"print_type": 2,
					"private": 1,
					"template_id": printForm['templateId'], //打印模板id
					"user_name": "掌递宝", //打印人名称
					"print_data": [{
						"tid": orderContent['orderNo'],
						"waybill_code": orderContent['waybillNo'],
						"cp_code": printForm['cpCode'],
						"sender": {
							"address": {
								"province": orderContent['sender']['provinceName'],
								"city": orderContent['sender']['cityName'],
								"district": orderContent['sender']['districtName'],
								"detail": orderContent['sender']['address']
							},
							"mobile": orderContent['sender']['mobile'],
							"name": orderContent['sender']['name'],
							"phone": ""
						},
						"recipient": {
							"address": {
								"province": orderContent['recipient']['provinceName'],
								"city": orderContent['recipient']['cityName'],
								"district": orderContent['recipient']['districtName'],
								"detail": orderContent['recipient']['address']
							},
							"mobile": orderContent['recipient']['mobile'],
							"name": orderContent['recipient']['name'],
							"phone": ""
						},
						"routing_info": {
							"consolidation": {
								"name": orderContent["sortInfo"]['assemblyPointName'],
								"code": orderContent["sortInfo"]['assemblyPointCode']
							},
							/* "origin": {
							    "code": "610025",
							    "name": "四川邛崃公司"
							}, */
							// "route_code": waybillData['sortingCode'],
							"sortation": {
								"name": orderContent["sortInfo"]['sortingCode']
							}
						},
						"note": orderContent['remark'],
						"package": orderContent['goods'][0]
					}]
				}
				let data = JSON.stringify(param);
				this.send_kb_PrinterMsg(data)
			},

			//快宝云打印
			//获取本地打印机列表
			getLocal_kb_Printer() {
				let data = JSON.stringify({
					"cmd": "getPrinters",
					"requestID": String(new Date().getTime()),
					"version": "1.0",
					"getStatus": "true"
				});
				this.send_kb_PrinterMsg(data)
			},
			/**
			 * 1. 建立WebSocket连接
			 */
			connect_Kb_Printer() {
				// 先关闭已有连接，避免重复连接
				// 断开WebSocket连接
				if (this.kbPrinter) {
					this.kbPrinter.close() // 主动关闭连接
					this.kbPrinter = null
					this.isConnected = false
				}
				// 检查浏览器兼容性
				if (!window.WebSocket) {
					alert('当前浏览器不支持WebSocket！')
					return
				}
				// 创建连接
				// this.kbPrinter = new WebSocket("ws://localhost:13628")
				//wss.kbydy.cn在用户有VPN情况下会连不上，未使用https网站打开或者允许权限会出现部分浏览器edge连不上
				this.kbPrinter = new WebSocket("ws://localhost:13628")
				// 连接成功回调
				this.kbPrinter.onopen = () => {
					this.isConnected = true
					this.kbPrinterMsgList.push({
						type: 'system',
						msg: 'WebSocket连接成功'
					})
					console.log('WebSocket已连接')
				}
				// 2. 接收服务端消息
				this.kbPrinter.onmessage = (e) => {
					// e.data 是服务端返回的消息（字符串格式）
					this.kbPrinterMsgList.push({
						type: 'recv',
						msg: e.data
					})
					var resMsg = JSON.parse(e.data)
					console.log('收到消息：', resMsg)
					if (resMsg.cmd == "getPrinters") {
						try {
							this.printerList = resMsg.printers;
						} catch {
							this.printerList = []
						}
					} else if (resMsg.cmd == "print") {
						var printResult = resMsg;
						console.log(printResult)
						if (printResult[this.orderNo]['status'] == 'success') {
							this.orderStatusUpdate(this.orderNo, 'PRINT'); //更新订单状态为已打印
							ElMessage({
								message: '打印完成',
								type: 'success',
							})
							location.reload();
							// setTimeout(() => {

							// }, 100)
						} else {
							ElMessage({
								message: '打印失败.' + printResult[this.orderNo]['message'],
								type: 'error',
							})
						}
					}
				}

				// 连接关闭回调
				this.kbPrinter.onclose = () => {
					this.isConnected = false;
					// 3秒后自动重连
					// setTimeout(() => {
					// 	this.connect_Kb_Printer();
					// }, 3000)
					console.log('WebSocket已断开');
				}

				// 连接错误回调
				this.kbPrinter.onerror = (err) => {
					ElMessage.error('快宝打印组件连接失败');
					this.isConnected = false;
					this.handleClose()
					this.kbPrinterMsgList.push({
						type: 'system',
						msg: 'WebSocket连接失败'
					})
					console.error('WebSocket错误：', err)
				}
			},

			/**
			 * 3. 发送消息到服务端
			 */
			send_kb_PrinterMsg(sendText) {
				if (!sendText.trim()) {
					alert('请输入消息内容！')
					return
				}
				if (!this.isConnected) {
					ElMessage.error('快宝打印组件未连接成功');
					return
				}
				try {
					// 发送消息（仅支持字符串，JSON需先序列化）
					this.kbPrinter.send(sendText.trim())
					// 记录发送的消息
					this.kbPrinterMsgList.push({
						type: 'send',
						msg: sendText.trim()
					})
					// 清空输入框
					sendText = ''
				} catch (err) {
					alert('发送失败：' + err.message)
				}
			},
			//获取电子面单账号列表
			getExpressAccountList() {
				apiService.post({
						modules: "getExpressAccountList",
						content: {}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.express_account_list = res.data.expressAccountList;
						}
					})
			},
			//更新订单状态
			orderStatusUpdate(orderNo, statusCode) {
				apiService.post({
						modules: "upOrderStatus",
						content: {
							orderNo: orderNo,
							statusCode: statusCode
						}
					})
					.then((res) => {
						//成功
						if (res.status) {
							console.log(res)
						}
					})
			},

			//选择电子面单赋值
			selectExpressAccount(item) {
				console.log(item)
				this.printForm.expressAccountId = item['id'];
				this.printForm.cpCode = item['cpCode'];
				this.printForm.expressAccountName = item['nickname'];
				//清除选择的打印模板
				this.printForm.templateId = ""
				console.log(this.printForm)
			},
			// 3. 新增遮罩层点击事件处理方法
			handleMaskClick() {
				this.handleClose()
			},
			handleClose() {
				// 触发close事件
				this.$emit('close')
			}
		},
		// 选项式API：监听属性变化
		watch: {
			visible(newVal) {
				console.log('弹窗状态变化：', newVal)
			}
		}
	}
</script>

<style scoped>
	.modal-mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		/* z-index: 9999; 
		调低，否则ElSelect下拉会被遮挡不显示
		*/
		z-index: 2;

	}

	.modal-container {
		/* width: 400px; */
		/* max-width: 90vw; */
		/* 适配小屏幕，防止弹窗超出视口 */
		background: white;
		border-radius: 8px;
		/* padding: 16px; */
		/* 关键：设置最大高度，防止整个弹窗超出视口 */
		max-height: 80vh;
		/* 弹性布局，让body区域自动填充剩余空间 */
		display: flex;
		flex-direction: column;
	}

	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		/* margin-bottom: 16px; */
		border-bottom: 1px solid #eee;
		padding-bottom: 8px;
		/* 固定头部高度，不参与滚动 */
		flex-shrink: 0;
		background-color: #007aff;
		padding: 10px;
		color: #fff;
		border-radius: 8px 8px 0 0;
	}

	.modal-header span {
		position: relative;
		width: 100%;
		text-align: center;
		font-size: 1.1em;
		font-family: sans-serif;
		font-weight: 400;
	}

	.modal-header button {
		background: transparent;
		border: none;
		font-size: 1.5em;
		cursor: pointer;
		color: #fff;
		position: relative;
		right: 2%;
	}

	/* 核心修改：解决内容溢出问题 */
	.modal-body {
		/* 自动填充剩余空间 */
		flex: 1;
		/* 设置最大高度，超出则滚动 */
		/* max-height: 300px; */
		/* 溢出自动显示滚动条 */
		overflow-y: auto;
		/* 优化滚动条样式（可选，提升体验） */
		/* scrollbar-width: thin;
		scrollbar-color: #ccc #f5f5f5; */
		margin: 20px;
	}



	/* .modal-footer {
  margin-top: 16px;
  text-align: right;
  flex-shrink: 0;
}

.modal-footer button {
  padding: 6px 12px;
  background: #1989fa;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
} */
</style>
<style>
	/* 1. 缩窄滚动条宽度 */
	.modal-body::-webkit-scrollbar {
		width: 3px !important;
		height: 3px !important;
	}

	/* 2. 隐藏滚动条上下箭头（关键！） */
	.modal-body::-webkit-scrollbar-button {
		display: none !important;
		/* 完全隐藏箭头按钮 */
	}

	/* 3. 隐藏滚动条轨道 */
	.modal-body::-webkit-scrollbar-track {
		background: transparent !important;
		border-radius: 3px !important;
	}

	/* 4. 圆滑透明滑块 */
	.modal-body::-webkit-scrollbar-thumb {
		background: rgba(224, 224, 224, 0.3) !important;
		border-radius: 3px !important;
		border: none !important;
	}

	/* 5. hover加深透明度 */
	.modal-body::-webkit-scrollbar-thumb:hover {
		background: rgba(224, 224, 224, 0.3) !important;
	}

	/* 6. Firefox适配（Firefox默认无滚动条箭头，无需额外处理） */
	.modal-body {
		scrollbar-width: thin !important;
		scrollbar-color: rgba(224, 224, 224, 0.3) transparent !important;
	}
</style>